import * as Yup from "yup"
import _ from "lodash"

const isValidUSPhone = (phoneNumber) => {
  if (!phoneNumber) return true
  const cleanedNumber = phoneNumber.replace(/\D/g, "")
  return phoneNumber.startsWith("+1") && cleanedNumber.length === 11
}

export default function validation_conditional_phone(field, acc) {
  const { field_name, field_validation } = field

  const conditions = JSON.parse(field.field_conditional)
  const fieldConditional = _.keys(conditions)
  const conditionFieldName = fieldConditional[0]

  const checkBool = () => {
    if (!field_validation?.required) return false
    return field_validation.required[0] === "true"
  }

  const isRequired = checkBool()
  const isRequiredTxt =
    (field_validation?.required && field_validation.required[1]) ||
    "Required field."
  const invalidPhoneTxt =
    "Please enter a valid US phone number (maximum 11 digits)"

  const conditionalBaseSchema = Yup.string()
    .nullable()
    .test("is-valid-us-phone", invalidPhoneTxt, (value) =>
      isValidUSPhone(value),
    )

  const requiredConditionalSchema = isRequired
    ? conditionalBaseSchema.required(isRequiredTxt)
    : conditionalBaseSchema

  return {
    [field_name]: conditionalBaseSchema.when(conditionFieldName, {
      is: (value) => {
        if (_.isArray(value)) {
          return _.some(value, (v) =>
            _.includes(conditions[conditionFieldName], v),
          )
        }
        return _.includes(conditions[conditionFieldName], value)
      },
      then: requiredConditionalSchema,
      otherwise: conditionalBaseSchema,
    }),
    ...acc,
  }
}
